import { createFileRoute } from "@tanstack/react-router";
import { MfeLoader } from "../../mfe/MfeLoader";
import { getNhiOlcmHostConfig } from "../../config/nhiOlcmHostConfig";
import { useHostNavigate } from "../../hooks/useHostNavigate";
import { usePermissionState } from "../../contexts/PermissionStateContext";

export const Route = createFileRoute("/nhi-olcm/")({
  component: NhiOlcmPage,
});

function NhiOlcmPage() {
  const onNavigate = useHostNavigate();
  const permissionState = usePermissionState();
  return (
    <MfeLoader
      name="nhi-olcm"
      props={{ hostConfig: getNhiOlcmHostConfig(onNavigate, permissionState) }}
    />
  );
}
